<template>
    <div>
        <Drawer
            v-if="selectedChaincodeInvocation"
            :drawerStatus="selectedChaincodeInvocationDrawerStatus"
            drawerWidth='69%'
            zIndex=200
            :title="selectedChaincodeInvocation.chaincode_name + '::' + selectedChaincodeInvocation.chaincode_function"
            :subtitle="toLongFormat(selectedChaincodeInvocation.start_time)"
            v-on:onDismiss="selectedChaincodeInvocationDrawerStatus = 'collapsed'"
            v-on:onOverlayClicked="chaincodeInvocationsDrawerStatus = 'collapsed'; selectedChaincodeInvocationDrawerStatus = 'collapsed'">
            <BlockchainRequestView
                class="px-5"
                :selectedBlockchainTxn="selectedChaincodeInvocation"
                v-on:onDismissView="chaincodeInvocationsDrawerStatus = 'collapsed'; selectedChaincodeInvocationDrawerStatus = 'collapsed'">
            </BlockchainRequestView>
        </Drawer>

        <Drawer
            v-if="selectedChaincodeInvocationSummary"
            :drawerStatus="chaincodeInvocationsDrawerStatus"
            drawerWidth='85%'
            zIndex=100
            :title="selectedChaincodeInvocationSummary.chaincode_name + '::' + selectedChaincodeInvocationSummary.chaincode_function"
            :subtitle="getFriendlySelectedTimePeriodStart + ' - ' +  getFriendlySelectedTimePeriodEnd "
            v-on:onDismiss="chaincodeInvocationsDrawerStatus = 'collapsed'"
            v-on:onOverlayClicked="chaincodeInvocationsDrawerStatus = 'collapsed'">
            <v-row class="mx-5" no-gutters>
                <v-col>
                    <v-row no-gutters>
                        <v-col>
                            <BarWithContrast
                                title="Average Execution Time"
                                :mainValue="selectedChaincodeInvocationSummary.avg_response_time"
                                :contrastValue="selectedChaincodeInvocationSummary.contrast_avg_response_time"
                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                unit="ms"                                
                            />
                        </v-col>
                        <v-col>
                            <BarWithContrast
                                title="Throughput"
                                :mainValue="selectedChaincodeInvocationSummary.tp_per_min"
                                :contrastValue="selectedChaincodeInvocationSummary.contrast_tp_per_min"
                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                unit="exec/min"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <BarWithContrast
                                title="Success Rate"
                                :mainValue="selectedChaincodeInvocationSummary.success_percent"
                                :contrastValue="selectedChaincodeInvocationSummary.contrast_success_percent"
                                relativeValue="100"
                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                unit="%"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2>No. of invocations: <span class="text-h4">{{ selectedChaincodeInvocationSummary.request_count }}</span></h2>
                            <v-data-table
                                :headers="chaincodeInvocationHeaders"
                                :items="chaincodeInvocations"
                                item-key="ravenpod_txn_id"
                                single-select
                                single-expand                                
                                show-expand
                                @item-expanded="handleCallerURLExpand">
                                    <template v-slot:item.start_time="{ item }">
                                        <a @click="handleChaincodeInvocationClick(item)" class="font-weight-bold">{{ toShortFormatWithAmPm(item.start_time) }}</a>
                                    </template>
                                    <template v-slot:item.end_time="{ item }">
                                        {{ toShortFormatWithAmPm(item.end_time) }}
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.status" size="24" color="green">mdi-checkbox-marked-circle</v-icon>
                                        <v-icon v-else size="24" color="red">mdi-alert-circle</v-icon>
                                    </template>
                                    <template v-slot:item.completion_time="{ item }">
                                        <BarWithContrast
                                            :mainValue="item.completion_time"
                                            :contrastValue="selectedChaincodeInvocationSummary.contrast_avg_response_time"
                                            :relativeValue="Math.max(selectedChaincodeInvocationSummary.contrast_avg_response_time, chaincodeInvocations.maxValueInAttributes('completion_time'))"
                                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                                            unit="ms"
                                            chartSize="small"/>
                                    </template>
                                    <template v-slot:item.caller_url="{ item }">                                        
                                        {{ item.caller_url}}
                                    </template>
                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="2"></td>
                                        <td :colspan="headers.length - 2" class="px-0">
                                            <v-card v-if="selectedWebTxn" class="py-2 px-4" dark color="#385F73" width="100%">                                                
                                                <h3 class="pb-4">{{ item.caller_url }}&nbsp;<span class="text-overline">{{ toShortFormatWithAmPm(selectedWebTxn.start_time) }} - {{ toShortFormatWithAmPm(selectedWebTxn.end_time) }}</span></h3>
                                                <v-row no-gutters>
                                                    <v-col>
                                                        <BarWithContrast
                                                            title="Total transaction time"
                                                            :mainValue="selectedWebTxn.ttl_txn_time"
                                                            :contrastValue="selectedWebTxn.contrast_ttl_txn_time"
                                                            :relativeValue="[selectedWebTxn].maxValueInAttributes('ttl_txn_time', 'contrast_ttl_txn_time', 'ttl_bc_time', 'contrast_ttl_bc_time')"
                                                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                                                            unit="ms"
                                                            chartSize="small"/>
                                                    </v-col>
                                                    <v-col>
                                                        <BarWithContrast
                                                            title="Time spent in blockchain"
                                                            :mainValue="selectedWebTxn.ttl_bc_time"
                                                            :contrastValue="selectedWebTxn.contrast_ttl_bc_time"
                                                            :relativeValue="[selectedWebTxn].maxValueInAttributes('ttl_txn_time', 'contrast_ttl_txn_time', 'ttl_bc_time', 'contrast_ttl_bc_time')"
                                                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                                                            unit="ms"
                                                            chartSize="small"/>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters>
                                                    <v-col>
                                                        <apexchart v-if="webTransactionFlowChartSeries[0].data.length > 0" height="240" width="850" :options="webTransactionFlowChartOptions" :series="webTransactionFlowChartSeries"></apexchart>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </td>                                                                              
                                    </template>                                    
                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-col>

            </v-row>
        </Drawer>

        <v-overlay @click.native="chaincodeInvocationsDrawerStatus = 'collapsed'" :value="chaincodeInvocationsDrawerStatus == 'expanded'" z-index="50"></v-overlay>

        <v-row justify="space-between">
            <v-col cols="10">
                <h2 class="text-uppercase font-weight-light">
                    Blockchain&nbsp;Performance&nbsp;>&nbsp;{{ currentWebAppName }}&nbsp;>&nbsp;
                    <span class="font-weight-medium">{{ currentChannel }}</span>
                    <span class="ml-4 text-subtitle-1 font-weight-light">{{ getFriendlySelectedTimePeriodStart }} - {{ getFriendlySelectedTimePeriodEnd }}</span>
                    <TimePeriodSelection
                        buttonText="Last"
                        :defaultSelection="getTimeSelection"
                        v-on:onTimePeriodSelected="onTimePeriodSelected"/>
                    <TimePeriodSelection
                        buttonText="Contrast to"
                        :defaultSelection="getContrastTimeSelection"
                        v-on:onTimePeriodSelected="onContrastTimePeriodSelected"/>
                    <!-- <v-btn text small color="primary" @click="generateTestData1">Get Test Data</v-btn> -->
                </h2>
            </v-col>
            <v-col cols="2">
                <AutoRefresh class="mt-n4" v-on:onRefresh="onRefresh"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <h3 class="text-uppercase underlined-title">Channel Performance</h3>
                <v-row>
                    <v-col>
                        <BarWithContrast
                            title="Average Chaincode Execution Time"
                            :mainValue="ccAvgRT"
                            :contrastValue="ccContrastAvgRT"
                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                            unit="ms"                                
                        />
                    </v-col>
                    <v-col>
                        <BarWithContrast
                            title="Chaincode Throughput"
                            :mainValue="ccTP"
                            :contrastValue="ccContrastTP"
                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                            unit="exec/min"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BarWithContrast
                            title="Success Rate"
                            :mainValue="ccSuccessRate"
                            :contrastValue="ccContrastSuccessRate"
                            :relativeValue="100"
                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                            unit="%"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <h3 class="text-uppercase underlined-title">Chaincode Performance Summary</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :headers="chaincodeInvocationSummaryHeaders"
                            :items="chaincodeInvocationSummary"
                            item-key="chaincode_function + '::' + chaincode_name"
                            single-select
                            hide-default-footer
                            @click:row="handleChaincodeInvocationSummaryTableClick">
                                <template v-slot:item.chaincode_name="{ item }">
                                    {{ item.chaincode_name  + ":: " + item.chaincode_function }}
                                </template>
                                <template v-slot:item.request_count="{ item }">
                                    {{ standardFormat(item.request_count) }}
                                </template>
                                <template v-slot:item.avg_response_time="{ item }">
                                    <BarWithContrast
                                        :mainValue="item.avg_response_time"
                                        :contrastValue="item.contrast_avg_response_time"
                                        :relativeValue="chaincodeInvocationSummary.maxValueInAttributes('avg_response_time', 'contrast_avg_response_time')"
                                        v-bind:contrastPeriodCode="getContrastTimeSelection"
                                        unit="ms"
                                        chartSize="small"
                                    />
                                </template>
                                <template v-slot:item.tp_per_min="{ item }">
                                    <BarWithContrast
                                        :mainValue="item.tp_per_min"
                                        :contrastValue="item.contrast_tp_per_min"
                                        :relativeValue="chaincodeInvocationSummary.maxValueInAttributes('tp_per_min', 'contrast_tp_per_min')"
                                        v-bind:contrastPeriodCode="getContrastTimeSelection"
                                        unit="exec/min"
                                        chartSize="small"
                                    />
                                </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <h3 class="text-uppercase underlined-title">Network Real Time Status</h3>
                <v-row class="mt-4 mb-2">
                    <v-col class="pt-0 pb-3" cols="4">
                        <h5 class="font-weight-light">Organization</h5>
                        <span>{{ getNumberOfOrganizations }}</span>
                    </v-col>
                    <v-col class="pt-0 pb-3" cols="4">
                        <h5 class="font-weight-light">Endorsers</h5>
                        <span>{{ getUpAndRunningCount(endorsers).up }} / {{ getUpAndRunningCount(endorsers).total }} running</span>
                    </v-col>
                    <v-col class="pt-0 pb-3" cols="4">
                        <h5 class="font-weight-light">Orderers</h5>
                        <span>{{ getUpAndRunningCount(orderers).up }} / {{ getUpAndRunningCount(orderers).total }} running</span>
                    </v-col>
                </v-row>
                <!-- <TopologyLegend/> -->
                <v-row no-gutters>
                    <v-col>
                        <d3-network @mouse-over="handleNodeMouseOver" @mouse-leave="handleNodeMouseLeave" :net-nodes="generateNodes" :net-links="generateLinks" :options="nodeOptions" />
                    </v-col>
                </v-row>    
                <v-row>
                    <v-col>
                        <!-- NODE INFORMATION START -->
                        <v-expand-transition>
                            <v-card class="pa-4" v-if="selectedNode" color="#E3F2FD">
                                <h3>
                                    {{ selectedNode.name }}
                                    <template v-if="selectedNode.ping_report.reachable">
                                        <v-icon  color="green">mdi-check-circle</v-icon>
                                        <span class="ml-2 text-body-1">PING {{ selectedNode.ping_report.average_time }} ms</span>
                                    </template>
                                    <template v-else>
                                        <v-icon color="red">mdi-alert-circle</v-icon>
                                        <span class="red--text ml-2 text-body-1 font-weight-bold">Unreachable</span>    
                                    </template>
                                </h3>
                                <v-row class="mt-3">
                                    <v-col>
                                        <BarWithContrast
                                            title="Average Endorsement Time"
                                            :mainValue="selectedNodeAvgEndorsementTime"
                                            :contrastValue="selectedNodeContrastAvgEndorsementTime"
                                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                                            unit="ms"
                                            chartSize="small"
                                        />
                                    </v-col>
                                    <v-col>
                                        <BarWithContrast
                                            title="Throughput"
                                            :mainValue="selectedNodeTP"
                                            :contrastValue="selectedNodeContrastTP"
                                            v-bind:contrastPeriodCode="getContrastTimeSelection"
                                            unit="exec/min"
                                            chartSize="small"
                                        />
                                    </v-col>
                                </v-row>
                                <h4 class="mt-3 text-uppercase font-weight-regular">Endorsing the following chaincodes</h4>
                                <v-row>
                                    <v-col class="text-caption">Chaincode name</v-col>
                                    <v-col class="text-caption">Average Endorsement Time (ms)</v-col>
                                    <v-col class="text-caption">Throughput (exec/min)</v-col>
                                </v-row>
                                <v-row v-if="selectedNodeVitalDataGroupByChaincode.length == 0" justify="center">
                                    <v-col cols="3" class="text-center grey--text">No data available</v-col>
                                </v-row>
                                <template v-for="(record, index) in selectedNodeVitalDataGroupByChaincode" >
                                    <!-- { avg_completion_time: 150, chaincode_name: "marble", tp_per_min: "1.89" } -->
                                    <v-row :key="index">
                                        <v-col><h3>{{ record.chaincode_name }}</h3></v-col>
                                        <v-col>
                                            <BarWithContrast
                                                :mainValue="record.avg_completion_time"
                                                :contrastValue="record.contrast_avg_completion_time"
                                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                                unit="ms"
                                                chartSize="small"/>
                                        </v-col>
                                        <v-col>
                                            <BarWithContrast
                                                :mainValue="record.tp_per_min"
                                                :contrastValue="record.contrast_tp_per_min"
                                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                                unit="exec/min"
                                                chartSize="small"
                                            />
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-card>
                        </v-expand-transition>
                        <!-- NODE INFORMATION END -->
                    </v-col>
                </v-row>    
            </v-col>
        </v-row>

    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import D3Network from 'vue-d3-network'

    import Api from '@/services/api'    
    import TimeHelper from '@/helpers/time_helper'
    import NumberHelper from '@/helpers/number_helper'
    import ToplogyHelper from '@/helpers/topology_helper'
    import ColorHelper from '@/helpers/color_helper'
    import Constants from '@/config/constants'

    import AutoRefresh from '@/components/AutoRefresh.vue'
    import TimePeriodSelection from '@/components/TimePeriodSelection.vue'    
    import BarWithContrast from '@/components/BarWithContrast.vue'
    import TopologyLegend from '@/components/TopologyLegend.vue'
    import BlockchainRequestView from '@/components/BlockchainRequestView.vue'
    import Drawer from '@/components/Drawer.vue'

    export default {

        components: {
            TimePeriodSelection, AutoRefresh, BarWithContrast, D3Network, BlockchainRequestView, Drawer
        },

        mounted: function () {
            this.setDefaultTimePeriod();
            this.getChannelVitalData();
            this.getContrastChannelVitalData();
            this.getChaincodeInvocationList();
            this.getChannelTopology();
        },

        computed: {            

            ...mapGetters([
                'currentWebAppName',
                'currentChannel',
                'getTimeSelection',
                'getContrastTimeSelection',
                'selectedTimePeriodStart',
                'selectedTimePeriodEnd',
                'contrastTimePeriodStart',
                'contrastTimePeriodEnd',            
                'getFriendlySelectedTimePeriodStart',
                'getFriendlySelectedTimePeriodEnd'    
            ]),

            generateNodes: function() {
                return ToplogyHelper.generateNodes(this.endorsers, this.orderers, 'large', true);
            },

            generateLinks: function() {
                return ToplogyHelper.generateLinks(this.endorsers, this.orderers, 'large', true);
            },

            getNumberOfOrganizations: function() {
                return ToplogyHelper.getNumberOfOrganizations(this.endorsers, this.orderers);
            },

        },

        methods: {

            ...NumberHelper,

            ...TimeHelper,

            ...mapActions([
                'setTimeSelection',
                'setContrastTimeSelection',
            ]),      

            setDefaultTimePeriod: function() {
                this.setTimeSelection(this.getTimeSelection)
                this.setContrastTimeSelection(this.getContrastTimeSelection)
            },

            onRefresh: function() {
                this.setTimeSelection(this.getTimeSelection);
                this.setContrastTimeSelection(this.getContrastTimeSelection);
                this.getChannelVitalData();
                this.getContrastChannelVitalData();
                this.getChaincodeInvocationList();
                this.getChannelTopology();
            },

            onTimePeriodSelected: function(numOfMinutesAgo) {
                this.setTimeSelection(numOfMinutesAgo);
                this.onRefresh()
            },

            onContrastTimePeriodSelected: function(numOfMinutesAgo) {
                this.setContrastTimeSelection(numOfMinutesAgo);
                this.onRefresh()
            },

            handleChaincodeInvocationClick: function(item) {
                console.log("selectedChaincodeInvocation:", item);
                this.selectedChaincodeInvocation = item
                // slot.select(true);                
                this.selectedChaincodeInvocationDrawerStatus = 'expanded'
            },

            handleCallerURLExpand: function(expandedItem, value) {
                let webTxnId = expandedItem.item.web_txn_id;
                if (webTxnId != this.selectedWebTxnId && expandedItem.value) {
                    console.log("Selected web txn id = ", webTxnId)
                    this.selectedWebTxnId = webTxnId
                    Api.webRequests.getVitalDataByWebTxnId(
                        {
                            app_name: this.currentWebAppName,
                            web_txn_id: this.selectedWebTxnId,
                        }
                    )
                    .then(response1 => {
                        console.log("Web transaction vital data", response1.data)
                        this.selectedWebTxn = response1.data
                        Api.webRequests.getVitalDataByURI(
                            {
                                time_period_start: this.contrastTimePeriodStart,
                                time_period_end: this.contrastTimePeriodEnd,
                                app_name: this.currentWebAppName,
                                uri: this.selectedWebTxn.uri
                            }                    
                        )
                        .then(response2 => {
                            console.log("Vital data by URI %s", this.selectedWebTxn.uri, response2.data)
                            this.$set(this.selectedWebTxn, 'contrast_ttl_txn_time', response2.data.avg_txn_time)
                            this.$set(this.selectedWebTxn, 'contrast_ttl_bc_time', response2.data.avg_bc_time)
                        })

                        Api.blockchainRequests.getBlockchainRequestListByWebTxnId({web_txn_id: this.selectedWebTxnId})
                        .then((response1) => {
                            console.log("Blockchain requests", response1.data)
                            let flowData = []
                            ColorHelper.resetColorIndex();
                            this.selectedWebTxnBlockchainRequests = response1.data
                            let requests = response1.data 
                            for (let index = 0; index < requests.length; index++) {
                                let request = requests[index]
                                flowData.push(
                                    {
                                        x: `${request.chaincode_name}::${request.chaincode_function}`,
                                        y: [
                                            TimeHelper.toEpochTimeFromJSONDate(request.start_time),
                                            TimeHelper.toEpochTimeFromJSONDate(request.end_time)
                                        ]
                                    }
                                )
                                Api.blockchainRequests.getVitalDataByChaincodeFunc({
                                    channel_name: request.channel_name,
                                    chaincode_name: request.chaincode_name,
                                    chaincode_function: request.chaincode_function,
                                    time_period_start: this.contrastTimePeriodStart,
                                    time_period_end: this.contrastTimePeriodEnd,
                                })
                                .then( (response2) => {
                                    console.log("Vital data by chaincode name and function", response2)
                                    this.$set(this.selectedWebTxnBlockchainRequests[index], 'contrast_completion_time', response2.data.avg_completion_time)
                                })
                            }                    
                            flowData.push(
                                {
                                    x: 'Web server response time',
                                    y: [
                                        TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.start_time),
                                        TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.end_time)
                                    ]
                                }
                            )
                            const logicalEndTime = Math.max.apply(Math, flowData.map(function(o) { return o.y[1]; }))
                            flowData.push(
                                {
                                    x: 'Logical transaction time',
                                    y: [
                                        TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.start_time),
                                        logicalEndTime,
                                    ]
                                }
                            )
                            this.$set(this.webTransactionFlowChartSeries, 0, { name: 'Web Transaction Flow', data: flowData } )
                        })

                    })




                }
            },

            handleChaincodeInvocationSummaryTableClick: function(item, row) {
                console.log("selectedChaincodeInvocationSummary:", item);
                this.selectedChaincodeInvocationSummary = item
                row.select(true);                
                this.chaincodeInvocationsDrawerStatus = 'expanded'
                Api.channels.getInvocationListByChannelAndChaincode(
                    {
                        time_period_start: this.selectedTimePeriodStart,
                        time_period_end: this.selectedTimePeriodEnd,
                        app_name: this.currentWebAppName,
                        channel_name: this.currentChannel,
                        chaincode_name: this.selectedChaincodeInvocationSummary.chaincode_name,
                        chaincode_function: this.selectedChaincodeInvocationSummary.chaincode_function
                    }
                )
                .then(response => {
                    console.log("Invocation list by channel and chaincode", response.data)
                    // [{ blockchain_txn_id: "de1a9925-610a-4b67-a8e6-dc408e5c28e9", end_time: "2021-01-12T18:06:57.173Z", is_success: 1, response_time: 2454, start_time: "2021-01-12T18:06:54.719Z" , uri: "/api/marbles/createReadAndUpdate", url: "/api/marbles/createReadAndUpdate", web_txn_id: "881058e9-c722-45ea-adeb-93580d84e14f"}, ...]
                    this.chaincodeInvocations = response.data
                })
            },

            getChannelVitalData: function() {
                Api.channels.getVitalDataByChannel(
                    {
                        time_period_start: this.selectedTimePeriodStart,
                        time_period_end: this.selectedTimePeriodEnd,
                        app_name: this.currentWebAppName,
                        channel_name: this.currentChannel
                    }
                )
                .then((response) => {
                    console.log("Channel vital data: ", response.data)
                    // { avg_response_time: 4762, success_rate: 100, tp_per_min: 1, ttl_num_of_succ_txn: 342, ttl_num_of_txn: 342
                    let vitalData = response.data
                    this.ccAvgRT = vitalData.avg_response_time
                    this.ccTP = vitalData.tp_per_min
                    this.ccSuccessRate = vitalData.success_rate
                })
            },

            getContrastChannelVitalData: function() {
                Api.channels.getVitalDataByChannel(
                    {
                        time_period_start: this.contrastTimePeriodStart,
                        time_period_end: this.contrastTimePeriodEnd,
                        app_name: this.currentWebAppName,
                        channel_name: this.currentChannel
                    }
                )
                .then((response) => {
                    console.log("Contrast channel vital data: ", response.data)
                    // { avg_response_time: 4762, success_rate: 100, tp_per_min: 1, ttl_num_of_succ_txn: 342, ttl_num_of_txn: 342
                    let vitalData = response.data
                    this.ccContrastAvgRT = vitalData.avg_response_time
                    this.ccContrastTP = vitalData.tp_per_min
                    this.ccContrastSuccessRate = vitalData.success_rate
                })
            },

            getChaincodeInvocationList: function() {
                Api.channels.getInvocationListByChannel(
                    {
                        time_period_start: this.selectedTimePeriodStart,
                        time_period_end: this.selectedTimePeriodEnd,
                        app_name: this.currentWebAppName,
                        channel_name: this.currentChannel
                    }
                )
                .then((response) => {
                    console.log("Chaincode invocation list: ", response.data)
                    // { avg_response_time: 7931, chaincode_function: "createMarble", chaincode_name: "marble", request_count: "137", tp_per_min: 2 }
                    this.chaincodeInvocationSummary = response.data
                    let txns = response.data

                    let allChaincodeNames = txns.map((txn) => { return txn.chaincode_name + '::' + txn.chaincode_function }).uniqueOnly()
                    for (const chaincodeName of allChaincodeNames) {
                        console.log("Getting vital data for", chaincodeName)
                        let pieces = chaincodeName.split('::')
                        let chaincode_name = pieces[0]
                        let chaincode_function = pieces[1]
                        Api.channels.getVitalDataByChannelAndChaincodeNameAndFunc(
                            {
                                time_period_start: this.contrastTimePeriodStart,
                                time_period_end: this.contrastTimePeriodEnd,
                                app_name: this.currentWebAppName,
                                channel_name: this.currentChannel,
                                chaincode_name: chaincode_name,
                                chaincode_function: chaincode_function
                            }
                        )
                        .then(response2 => {
                            console.log("Vital data by chaincode name %s::%s", chaincode_name, chaincode_function, response2.data)
                            // { avg_response_time: 7973, request_count: "281", tp_per_min: 0}
                            for (let index = 0; index < this.chaincodeInvocationSummary.length ; index++) {
                                if (chaincode_name == this.chaincodeInvocationSummary[index].chaincode_name && chaincode_function == this.chaincodeInvocationSummary[index].chaincode_function) {
                                    let currentData = this.chaincodeInvocationSummary[index]
                                    currentData.contrast_avg_response_time = response2.data.avg_response_time
                                    currentData.contrast_tp_per_min = response2.data.tp_per_min
                                    currentData.contrast_success_count = response2.data.success_count
                                    currentData.contrast_success_percent = response2.data.success_percent
                                    this.$set(this.chaincodeInvocationSummary, index, currentData)
                                }
                            }
                        })
                    }
                })
            },

            getChannelTopology: function() {
                Api.channels.getTopology({ app_name: this.currentWebAppName, channel_name: this.currentChannel })
                .then((response) => {
                    console.log("Channel topology: ", response.data)
                    this.endorsers = response.data.endorsers;
                    this.orderers = response.data.orderers;
                })
            },

            getUpAndRunningCount: function(peers) {
                return ToplogyHelper.getUpAndRunningCount(peers);
            },

            handleNodeMouseOver: function(event, nodeObject) {
                if (nodeObject._cssClass.includes('endorser')) {
                    for (let index = 0; index < this.endorsers.length; index++) {
                        if (this.endorsers[index].id == nodeObject.id) {
                            this.selectedNode = this.endorsers[index]
                            this.selectedNode.role = "Endorser"
                            break
                        }
                    }
                } else if (nodeObject._cssClass.includes('orderer')) {
                    for (let index = 0; index < this.orderers.length; index++) {
                        if (this.orderers[index].id == nodeObject.id) {
                            this.selectedNode = this.orderers[index]
                            this.selectedNode.role = "Orderer"
                            break
                        }
                    }                    
                }
                if (this.selectedNode) {
                    console.log("Selected node", this.selectedNode)
                    this.getEndorsementVitalDataByNode();
                    this.getContrastEndorsementVitalDataByNode();
                    this.getVitalDataByChannelAndHostnameAndStageGroupByChaincode();
                }
            },

            handleNodeMouseLeave: function(event, nodeObject) {
                this.selectedNode = null
            },

            getEndorsementVitalDataByNode: function() {
                Api.channels.getVitalDataByChannelAndHostnameAndStage({
                    time_period_start: this.selectedTimePeriodStart,
                    time_period_end: this.selectedTimePeriodEnd,
                    app_name: this.currentWebAppName,
                    channel_name: this.currentChannel,
                    hostname: this.selectedNode.name,
                    stage: Constants.BLOCKCHAIN_STEP_STAGE_ENDORSEMENT
                })
                .then((response) => {
                    console.log("Endorsement data by hostname: ", response.data)
                    // { avg_completion_time: 152, tp_per_min: 10 }
                    this.selectedNodeAvgEndorsementTime = response.data.avg_completion_time
                    this.selectedNodeTP = response.data.tp_per_min
                })
            },

            getContrastEndorsementVitalDataByNode: function() {
                Api.channels.getVitalDataByChannelAndHostnameAndStage({
                    time_period_start: this.contrastTimePeriodStart,
                    time_period_end: this.contrastTimePeriodEnd,
                    app_name: this.currentWebAppName,
                    channel_name: this.currentChannel,
                    hostname: this.selectedNode.name,
                    stage: Constants.BLOCKCHAIN_STEP_STAGE_ENDORSEMENT
                })
                .then((response) => {
                    console.log("Contrast endorsement data by hostname: ", response.data)
                    // { avg_completion_time: 152, tp_per_min: 10 }
                    this.selectedNodeContrastAvgEndorsementTime = response.data.avg_completion_time
                    this.selectedNodeContrastTP = response.data.tp_per_min
                })
            },

            getVitalDataByChannelAndHostnameAndStageGroupByChaincode: function() {
                Api.channels.getVitalDataByChannelAndHostnameAndStageGroupByChaincode({
                    time_period_start: this.selectedTimePeriodStart,
                    time_period_end: this.selectedTimePeriodEnd,
                    app_name: this.currentWebAppName,
                    channel_name: this.currentChannel,
                    hostname: this.selectedNode.name,
                    stage: Constants.BLOCKCHAIN_STEP_STAGE_ENDORSEMENT
                })
                .then((response) => {
                    console.log("Vital data group by chaincode: ", response.data)
                    // [ { avg_completion_time: 150, chaincode_name: "marble", tp_per_min: "1.89" }, ... ]
                    this.selectedNodeVitalDataGroupByChaincode = response.data
                    for (let index1 = 0; index1 < this.selectedNodeVitalDataGroupByChaincode.length ; index1++) {
                        let chaincodeName = this.selectedNodeVitalDataGroupByChaincode[index1].chaincode_name
                        Api.channels.getVitalDataByChannelAndHostnameAndStageAndChaincodeName(
                            {
                                time_period_start: this.contrastTimePeriodStart,
                                time_period_end: this.contrastTimePeriodEnd,
                                app_name: this.currentWebAppName,
                                channel_name: this.currentChannel,
                                hostname: this.selectedNode.name,
                                stage: Constants.BLOCKCHAIN_STEP_STAGE_ENDORSEMENT,
                                chaincode_name: chaincodeName
                            }
                        )
                        .then(response2 => {
                            console.log("Contrast vital data by chaincode %s", chaincodeName, response2.data)
                            // { avg_completion_time: 174, tp_per_min: "1.39"}
                            for (let index2 = 0; index2 < this.selectedNodeVitalDataGroupByChaincode.length ; index2++) {
                                if (chaincodeName == this.selectedNodeVitalDataGroupByChaincode[index2].chaincode_name) {
                                    let currentData = this.selectedNodeVitalDataGroupByChaincode[index2]
                                    currentData.contrast_avg_completion_time = response2.data.avg_completion_time
                                    currentData.contrast_tp_per_min = response2.data.tp_per_min
                                    this.$set(this.selectedNodeVitalDataGroupByChaincode, index2, currentData)
                                }
                            }
                        })
                    }
                })
            }

        },

        data: () =>  ({

            chaincodeInvocationSummaryHeaders: [
                { text: 'Name & Method', align: 'start', value: 'chaincode_name', width: 200 },
                { text: 'Invocation Count', value: 'request_count', width: 90 },
                { text: 'Average Execution Time (ms)', value: 'avg_response_time', width: 320 },
                { text: 'Throughput (exec/min)', value: 'tp_per_min', width: 340 },
            ],
            chaincodeInvocationSummary: [],
            ccAvgRT: 0,
            ccContrastAvgRT: 0,
            ccTP: 0,
            ccContrastTP: 0,
            ccSuccessRate: 0,
            ccContrastSuccessRate: 0,
            endorsers: [],
            orderers: [],
            nodeOptions: {
                size: {h: 480},
                offset: { x: 0, y: 0},      
                force: 4000,
                forces: {
                    X: 0.5,
                    Y: 1.0,
                    Center: false,
                },                
                nodeLabels: true,
                linkWidth: 1,
                canvas: false
            },
            selectedNode: null,
            selectedNodeAvgEndorsementTime: 0,
            selectedNodeContrastAvgEndorsementTime: 0,
            selectedNodeTP: 0,
            selectedNodeContrastTP: 0,
            selectedNodeVitalDataGroupByChaincode: [],
            chaincodeInvocationsDrawerStatus: 'collapsed',
            selectedChaincodeInvocationDrawerStatus: 'collapsed',
            chaincodeInvocationHeaders: [
                { text: 'Start Time', value: 'start_time', width: 130 },
                // { text: 'End Time', value: 'end_time', width: 60 },
                { text: 'Caller Location', align: 'start', value: 'remote_geolocation', width: 140 },
                { text: 'Caller URL', align: 'start', value: 'caller_url', width: 540 },
                { text: '', value: 'data-table-expand' },                
                { text: 'Chaincode Exec. Time', value: 'completion_time', width: 280 },
                { text: 'Chaincode Exec. Status', value: 'status', width: 10 },
            ],
            chaincodeInvocations: [],
            selectedChaincodeInvocationSummary: null,
            selectedChaincodeInvocation: null,
            selectedWebTxnId: null,
            selectedWebTxn: null,
            selectedWebTxnBlockchainRequests: [],
            webTransactionFlowChartSeries: [{name: 'Web Transaction Flow', data: []}],
            webTransactionFlowChartOptions: {
                chart: {
                    height: 180,
                    type: 'rangeBar',
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '80%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#FFF']
                    },
                    formatter: function(values, opt) {
                        return `${values[1] - values[0]}ms`
                    },
                },                            
                xaxis: {
                    type: 'datetime',
                    labels: {
                        style: {
                            colors: ['white'],
                            fontSize: '14px',                            
                        },                        
                        formatter: function (value, timestamp) {
                            return TimeHelper.toHHMMSSFormat(value)
                        },                                 
                    }                            
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: ['white'],
                            fontSize: '14px'
                        },
                        maxWidth: 360,                        
                    },
                },
                grid: {
                    show: false,
                },
                stroke: {
                    show: false
                },
                fill: {
                    type: 'solid',
                    opacity: 1,
                    colors: 
                        [
                            function({ value, seriesIndex, w }) {
                                return ColorHelper.getNextColorInSeries();
                            }                                    
                        ]
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: true,
                        formatter: function (value, timestamp) {
                            return TimeHelper.toShortFormat(value)
                        },                                 
                    },
                    y: {
                        title: {
                            formatter: (seriesName) => seriesName,
                        },                        
                    },
                    fixed: {
                        enabled: true,
                        position: 'topRight'
                    },                    
                }
            },

        })

    }
</script>

<style scoped lang="scss">
</style>


